import React from "react";
import { MessageCircle, Mail, ArrowRight, Check } from "lucide-react";
import { WHATSAPP_LINK, EMAIL_LINK, KAMRAN } from "../../data/programs";

const PROMISES = [
  "Zero fees, zero commission — Kamran is a volunteer",
  "Help in English, Urdu and Roman Urdu",
  "Reply within 24 hours, every working day",
  "All applications go through the official AIOU portal",
];

export const GuidanceCTA = () => {
  return (
    <section
      id="guidance"
      data-testid="guidance-cta"
      className="relative isolate overflow-hidden py-20 md:py-28"
    >
      <div className="absolute inset-0 -z-10 bg-aiou-steel" />
      <div
        aria-hidden
        className="absolute inset-0 -z-10 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }}
      />

      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 text-white">
            <span className="text-xs uppercase tracking-[0.2em] text-aiou-gold font-semibold">
              Personal admission guidance
            </span>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
              Get free, personal help from{" "}
              <span className="text-aiou-gold">Kamran Mir</span> — apply with
              confidence.
            </h2>
            <p className="mt-5 text-white/80 text-base sm:text-lg leading-relaxed max-w-2xl">
              Kamran has personally walked dozens of overseas students through
              the AIOU application — choosing the right program, paying fees
              from abroad, attesting documents, and starting classes on the
              LMS. Reach out today.
            </p>

            <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 max-w-xl">
              {PROMISES.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-2.5 text-sm text-white/90"
                >
                  <Check
                    className="h-4 w-4 mt-0.5 shrink-0 text-aiou-gold"
                    strokeWidth={2.2}
                  />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-3xl border border-white/15 bg-white/10 backdrop-blur-xl p-7 sm:p-8 text-white shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
              <div className="flex items-center gap-4 mb-6">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-aiou-gold text-aiou-steelDark font-serif text-2xl shadow-md">
                  KM
                </div>
                <div>
                  <div className="font-serif text-xl">{KAMRAN.name}</div>
                  <div className="text-xs text-white/70">
                    Free guidance · {KAMRAN.region}
                  </div>
                </div>
              </div>

              <a
                href={WHATSAPP_LINK()}
                target="_blank"
                rel="noreferrer"
                data-testid="cta-whatsapp"
                className="flex items-center justify-between rounded-2xl bg-emerald-500 hover:bg-emerald-400 transition-colors text-white px-5 py-4 mb-3 group"
              >
                <span className="flex items-center gap-3">
                  <MessageCircle className="h-5 w-5" strokeWidth={1.8} />
                  <span>
                    <span className="block text-[11px] uppercase tracking-wider text-white/80">
                      WhatsApp Kamran
                    </span>
                    <span className="block font-medium">
                      {KAMRAN.phoneDisplay}
                    </span>
                  </span>
                </span>
                <ArrowRight
                  className="h-5 w-5 group-hover:translate-x-0.5 transition-transform"
                  strokeWidth={1.8}
                />
              </a>

              <a
                href={EMAIL_LINK()}
                data-testid="cta-email"
                className="flex items-center justify-between rounded-2xl bg-white/15 hover:bg-white/25 transition-colors text-white px-5 py-4 group"
              >
                <span className="flex items-center gap-3">
                  <Mail className="h-5 w-5" strokeWidth={1.8} />
                  <span>
                    <span className="block text-[11px] uppercase tracking-wider text-white/70">
                      Email Kamran
                    </span>
                    <span className="block font-medium">{KAMRAN.email}</span>
                  </span>
                </span>
                <ArrowRight
                  className="h-5 w-5 group-hover:translate-x-0.5 transition-transform"
                  strokeWidth={1.8}
                />
              </a>

              <div className="mt-5 text-[11px] text-white/60 leading-relaxed">
                Kamran is an independent AIOU alumnus volunteering his time. He
                is not an AIOU employee and does not charge any fee.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
